import { CalculateDimensions } from "../horizontal_scrollbar.types";

export const calculateScrollableContainerDimensions = (
  clientX: number,
  {
    contentRef,
    scrollableContainer,
    scrollbarContainerRef,
    scrollbarRef,
    scrollbarDraggingData
  }: Omit<CalculateDimensions, "minThumbWidth" | "getContentWidth" | "getWindowWidth">
) => {
  if (
    !scrollbarDraggingData.current ||
    !scrollableContainer ||
    !contentRef.current ||
    !scrollbarContainerRef.current ||
    !scrollbarRef.current
  ) {
    return { scrollLeft: 0 };
  }

  const delta = clientX - scrollbarDraggingData.current.mouseX;
  const { clientWidth } = scrollbarContainerRef.current;

  const thumbWidth = scrollbarRef.current.clientWidth;
  const maxThumbLeft = clientWidth - thumbWidth;
  const maxScrollLeft = Math.max(0, scrollableContainer.scrollWidth - scrollableContainer.clientWidth);

  const scrollDelta = maxThumbLeft > 0 ? (delta / maxThumbLeft) * maxScrollLeft : 0;

  const scrollLeft = Math.max(
    0,
    Math.min(scrollbarDraggingData.current.scrollLeft + scrollDelta, maxScrollLeft)
  );
  return { scrollLeft };
};
